import $ from 'jquery';

let accordionEl = $('.accordion');

$(function () {
    if (accordionEl.length > 0) {
        bindToggleAccordion(accordionEl);
    }
});

function bindToggleAccordion(element) {
    element.find('.accordion-title').on('click', function (e) {
        let accordion = $(this).parent();
        let parent = accordion.closest('.accordion');
        let childList = parent.find('.accordion-item.active')
        childList.each(function() {
            let childAccordion = $(this);
            let childAnswer = childAccordion.children().get(1);
            $(childAnswer).slideUp(300);
            $(childAnswer).removeClass('active');
            childAccordion.removeClass('active');
        });

        let answer = accordion.children().get(1);
        if ($(answer).is(':hidden')) {
            $(answer).slideDown(300, function () {
                $(answer).addClass('active');
            });
            accordion.addClass('active');
        } else {
            $(answer).slideUp(300);
            $(answer).removeClass('active');
            accordion.removeClass('active');
        }
    });
}